angular.module 'zc.commonApi'

.factory "MongoSession", ($q, FacadeV2) ->


  class MongoSession

    @find: (query, options = {}) ->
      $q (resolve, reject) ->
        query ||= {}

        unless query.apikey
          return reject "No apikey"

        unless query._id or
              query._uuid or
              query.opened_at or
              (options.sort and options.sort.indexOf("opened_at") >= 0)
          return reject "no _id or apikey/opened_at provided"

        params =
          params:
            match: query
            sort: options.sort
            limit: options.limit || 1000
            fields: options.fields
            t: options.t if options.t
          ignoreLoadingBar: options.ignoreLoadingBar if options.ignoreLoadingBar

        FacadeV2.request "/apikeys/#{query.apikey}/sessions", params
        .then (res) ->
          if res.status != 200 || res.data.error
            reject res.data.error
          else
            resolve res.data

  MongoSession



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/facade/mongo_session.service.coffee